import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
import _Set from "@babel/runtime-corejs3/core-js/set";
import { useInstance, onBeforeUnmount } from 'intact-vue-next';
import { inArray, addOrRemove } from '../table/useChecked';
import { isDropdown } from './useDropdown';
export function useExpanded(rootMenu, parentMenu) {
  var instance = useInstance();
  onBeforeUnmount(removeSubExpandedKey);
  function isExpanded() {
    var isExpanded = !isDropdown(rootMenu) && inArray(rootMenu.get('expandedKeys'), instance.get('key'));
    if (isExpanded) {
      addSubExpandedKey();
    } else {
      removeSubExpandedKey();
    }
    return isExpanded;
  }
  function expand() {
    expandOrShrink(true);
  }
  function shrink() {
    expandOrShrink(false);
  }
  function toggle() {
    if (isExpanded()) {
      shrink();
    } else if (!rootMenu.get('accordion')) {
      expand();
    } else {
      // accordion
      var subExpandedKeys = parentMenu.subExpandedKeys;
      if (subExpandedKeys) {
        subExpandedKeys.forEach(function (key) {
          addOrRemove(rootMenu.get('expandedKeys'), key, false);
        });
      }
      expand();
    }
  }
  function expandOrShrink(isExpand) {
    var _context;
    var expandedKeys = _sliceInstanceProperty(_context = rootMenu.get('expandedKeys')).call(_context);
    addOrRemove(expandedKeys, instance.get('key'), isExpand);
    rootMenu.set({
      expandedKeys: expandedKeys
    });
  }
  function addSubExpandedKey() {
    var key = instance.get('key');
    var subExpandedKeys = parentMenu.subExpandedKeys || (parentMenu.subExpandedKeys = new _Set());
    subExpandedKeys.add(key);
  }
  function removeSubExpandedKey() {
    var key = instance.get('key');
    var subExpandedKeys = parentMenu.subExpandedKeys || (parentMenu.subExpandedKeys = new _Set());
    subExpandedKeys.delete(key);
  }
  return {
    isExpanded: isExpanded,
    expand: expand,
    shrink: shrink,
    toggle: toggle
  };
}